import {
  BarChart3,
  FileWarning,
  Flag,
  LayoutDashboard,
  Settings,
  ShieldCheck,
  Users,
  X,
} from "lucide-react";
import { NavLink } from "react-router-dom";

const AdminSidebar = ({ isOpen, onClose }) => {
  const menuItems = [
    { path: "/admin-dashboard", label: "Overview", caption: "Command center", icon: LayoutDashboard, end: true },
    { path: "/admin-dashboard/flagged", label: "Flagged", caption: "Moderation queue", icon: FileWarning },
    { path: "/admin-dashboard/users", label: "Users", caption: "Accounts and trust", icon: Users },
    { path: "/admin-dashboard/issues", label: "Issues", caption: "Reports workflow", icon: Flag },
    { path: "/admin-dashboard/claims", label: "Claims", caption: "Candidate review", icon: ShieldCheck },
    { path: "/admin-dashboard/analytics", label: "Analytics", caption: "Live platform signals", icon: BarChart3 },
    { path: "/admin-dashboard/settings", label: "Settings", caption: "Admin controls", icon: Settings },
  ];

  return (
    <>
      <aside
        className={`fixed left-0 top-0 z-50 flex h-full w-72 flex-col border-r border-[#d7dfd4] bg-[#f7f7f2] ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transform transition-transform duration-300 ease-out lg:translate-x-0`}
      >
        <div className="border-b border-[#d7dfd4] px-6 py-6">
          <div className="mb-4 flex items-center justify-between lg:justify-start">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-[#ff9933] via-white to-[#138808] text-lg font-bold text-slate-900 shadow-sm">
              JS
            </div>
            <button
              onClick={onClose}
              className="rounded-xl border border-slate-200 bg-white p-2 text-slate-500 lg:hidden"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-[#ff9933]">
            JanShakti Admin
          </p>
          <h2 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900">
            Governance Desk
          </h2>
          <p className="mt-2 text-sm leading-6 text-slate-500">
            A focused workspace for moderation, verification, and platform operations.
          </p>
        </div>

        <nav className="flex-1 space-y-2 overflow-y-auto px-4 py-5">
          {menuItems.map((item) => {
            const Icon = item.icon;

            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.end}
                onClick={onClose}
                className={({ isActive }) =>
                  `group flex items-center gap-3 rounded-2xl border px-4 py-3 transition-all duration-200 ${
                    isActive
                      ? "border-[#ffddb3] bg-gradient-to-r from-[#fff1df] via-white to-[#edf8ef] text-slate-900 shadow-sm"
                      : "border-transparent bg-transparent text-slate-600 hover:border-[#e9ede7] hover:bg-white hover:text-slate-900"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <div
                      className={`flex h-11 w-11 items-center justify-center rounded-2xl ${
                        isActive
                          ? "bg-gradient-to-br from-[#ff9933] to-[#138808] text-white"
                          : "bg-[#eef2ec] text-slate-600 group-hover:bg-[#fff1df]"
                      }`}
                    >
                      <Icon className="h-5 w-5" />
                    </div>
                    <div className="min-w-0">
                      <p className="text-sm font-semibold">{item.label}</p>
                      <p className="truncate text-xs text-slate-500">{item.caption}</p>
                    </div>
                  </>
                )}
              </NavLink>
            );
          })}
        </nav>

        <div className="border-t border-[#d7dfd4] px-6 py-5">
          <div className="rounded-3xl bg-slate-900 px-4 py-4 text-white shadow-lg shadow-slate-900/10">
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#ffcc80]">
              Admin Scope
            </p>
            <p className="mt-2 text-sm leading-6 text-slate-300">
              Internal-only dashboard. Public navigation is intentionally removed from this workspace.
            </p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;
